export default __webpack_public_path__ + "static/media/icon_box-widgets-phone.1b4a9b80.svg";